// Loader.jsx
import React from 'react';
import { Html, useProgress } from '@react-three/drei';
import './Loader.css';

export default function Loader() {
  const { progress } = useProgress();

  return (
    <Html center>
      <div className="loader-wrapper">
        <img src="/llamaLoader.gif" alt="Loading Llama" className="loader-gif" />
              <img
        src="/phlnr_logo1.png"
        alt="PHLNR Logo"
        className="loader-logo"
      />
        <div className="progress-bar">
          <div className="progress-fill" style={{ width: `${progress}%` }} />
        </div>

        <p className="loader-text">Loading Experience...</p>
      </div>
    </Html>
  );
}
